import {BurgerMenuContainerDefaultBox} from "./burger-menu-container.default.box";

export const BurgerMenuContainerBox = BurgerMenuContainerDefaultBox;